import { Button, Tooltip } from "@shopify/polaris"
import React, { useContext, useEffect, useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import KopyLogo from "../assets/kopy-logo-square.png"
import { CoolButton } from "../components/CoolButton.jsx"
import { GlowingButtonContainer } from "../components/GlowingButtonContainer.jsx"
import { TopMenu } from "../components/TopMenu.jsx"
import { Video } from "../components/Video.jsx"
import { GlobalStateContext } from "../components/providers/GlobalStateProvider.jsx"
import {
	useAddItemToSubscription,
	useGetProratedPriceWithTax,
} from "../hooks/usePaddleHooks.js"
import { Spinner } from "../components/Spinner.jsx"
import "../assets/kopy-plus-upgrade-card.css"
import { usePostHog } from "posthog-js/react"

const KopyPlusPricingCard = ({
	billingInterval,
	priceInUsd,
	onButtonClick,
	buttonPrice,
}) => {
	const { t } = useTranslation()

	return (
		<div
			className="kopy-plus-pricing-card pricing-card"
			style={{
				padding: "1.5rem",
				borderRadius: "1rem",
				position: "relative",
			}}
		>
			<div style={{ display: "flex", gap: "1rem" }}>
				<div
					style={{
						position: "relative",
						width: "4rem",
						height: "4rem",
					}}
				>
					<img
						src={KopyLogo}
						style={{
							width: "4rem",
							height: "4rem",
							borderRadius: "1rem",
						}}
					/>
					<div
						style={{
							position: "absolute",
							top: "-0.6rem",
							right: "-0.6rem",
							color: "#fff",
						}}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="1.9rem"
							height="1.9rem"
							viewBox="0 0 24 24"
						>
							<g fill="none" fillRule="evenodd">
								<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
								<path
									fill="currentColor"
									d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
								></path>
							</g>
						</svg>
					</div>
				</div>
				<div>
					<p
						style={{
							fontSize: "1.5rem",
							fontWeight: "bold",
							color: "#fff",
						}}
					>
						Kopy Plus
					</p>
					<div
						style={{
							display: "flex",
							alignItems: "baseline",
							gap: "0.3rem",
						}}
					>
						<Tooltip
							content={
								<div
									style={{
										padding: "0.4rem 0.7rem",
										width: "25rem",
									}}
								>
									{/* <p style={{ fontSize: "0.9rem", color: "#333" }}>The Kopy Plus add-on gives you access to all the features that Kopy Plus offers to your whole account.</p> */}
									<p
										style={{
											fontSize: "0.9rem",
											color: "#333",
											marginTop: "0.5rem",
										}}
									>
										{t(
											"upgrade_plus.you_will_be_able_to_enjoy_the_benefits_of_kopy_plus_in_all_your_stores",
										)}
									</p>
									<p
										style={{
											fontSize: "0.75rem",
											color: "#777",
											marginTop: "0.5rem",
										}}
									>
										{t(
											"upgrade_plus.the_benefits_will_also_apply_for_staff_accounts_for_the_stores_you_have_delegated_them_access_to",
										)}
									</p>
								</div>
							}
						>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: "0.3rem",
								}}
							>
								<p
									className="info-underline"
									style={{
										fontSize: "0.9rem",
										fontWeight: "400",
										color: "#eee",
									}}
								>
									Add-on
								</p>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="1rem"
									height="1rem"
									viewBox="0 0 24 24"
								>
									<path
										fill="#fff"
										d="M11.95 18q.525 0 .888-.363t.362-.887q0-.525-.362-.888t-.888-.362q-.525 0-.887.363t-.363.887q0 .525.363.888t.887.362m-.9-3.85h1.85q0-.825.188-1.3t1.062-1.3q.65-.65 1.025-1.238T15.55 8.9q0-1.4-1.025-2.15T12.1 6q-1.425 0-2.312.75T8.55 8.55l1.65.65q.125-.45.563-.975T12.1 7.7q.8 0 1.2.438t.4.962q0 .5-.3.938t-.75.812q-1.1.975-1.35 1.475t-.25 1.825M12 22q-2.075 0-3.9-.787t-3.175-2.138q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8"
									></path>
								</svg>
							</div>
						</Tooltip>
					</div>
				</div>
			</div>

			<div
				style={{
					fontSize: "1.3rem",
					color: "#fff",
					fontWeight: "600",
					marginTop: "1.3rem",
					lineHeight: "1.2",
					paddingBottom: "1rem",
					borderBottom: "1px solid #ccc3",
				}}
			>
				{t(
					"upgrade_plus.unlock_the_full_power_of_kopy_ai_on_all_stores_linked_to_your_account",
				)}
			</div>

			{billingInterval === "monthly" ? (
				<div
					style={{
						display: "flex",
						gap: "0.1rem",
						alignItems: "end",
						margin: "1rem 0rem",
					}}
				>
					<p
						style={{
							fontSize: "3rem",
							fontWeight: "700",
							color: "#fff",
							lineHeight: "1.1",
						}}
					>
						$9.99
					</p>
					<div>
						<p
							style={{
								fontSize: "0.8rem",
								fontWeight: "700",
								color: "#00ad00",
							}}
						>
							{t("upgrade_plus.50_off_only_this_month")}
						</p>
						<p
							style={{
								fontSize: "1.2rem",
								fontWeight: "700",
								color: "#fff",
							}}
						>
							$
							<span style={{ textDecoration: "line-through" }}>
								{priceInUsd}
							</span>
							<span
								style={{ fontSize: "1rem", fontWeight: "400" }}
							>
								{" "}
								{t("upgrade_plus.month")}
							</span>
						</p>
					</div>
				</div>
			) : (
				<p
					style={{
						fontSize: "3rem",
						fontWeight: "700",
						color: "#fff",
					}}
				>
					${priceInUsd}
					<span style={{ fontSize: "1rem", fontWeight: "400" }}>
						{" "}
						{billingInterval === "monthly"
							? t("upgrade_plus.month")
							: billingInterval === "yearly"
								? t("account.year")
								: t("account.quarterly")}
					</span>
				</p>
			)}

			<p
				style={{
					fontSize: "1.2rem",
					fontWeight: "500",
					color: "#fff",
					marginTop: "1.2rem",
				}}
			>
				{t("upgrade_plus.whats_included")}
			</p>

			<div
				style={{
					fontSize: "1rem",
					marginTop: "0.7rem",
					marginBottom: "3rem",
					display: "flex",
					flexDirection: "column",
					gap: "0.5rem",
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "start",
						gap: "0.5rem",
						color: "#fff",
					}}
				>
					<svg width="1.2rem" height="1.2rem" viewBox="0 0 24 24">
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span
						style={{
							fontSize: "1rem",
							fontWeight: "400",
							lineHeight: "1.2",
						}}
					>
						{t("upgrade_plus.all_kopy_basic_features")}
					</span>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "start",
						gap: "0.5rem",
						color: "#fff",
					}}
				>
					<svg width="1.2rem" height="1.2rem" viewBox="0 0 24 24">
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span
						style={{
							fontSize: "1rem",
							fontWeight: "400",
							lineHeight: "1.2",
						}}
					>
						<Tooltip
							content={
								<div
									style={{
										width: "30rem",
										padding: "0.5rem",
									}}
								>
									<Video
										isInsideTooltip={true}
										videoSrc="https://kopy.b-cdn.net/translate_preview.webm"
									/>
								</div>
							}
						>
							<span className="info-underline">
								{t("upgrade_plus.ai_translations")}
							</span>
						</Tooltip>
						<span> {t("upgrade_plus.to_any_language")}</span>
					</span>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "start",
						gap: "0.5rem",
						color: "#fff",
					}}
				>
					<svg width="1.2rem" height="1.2rem" viewBox="0 0 24 24">
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span
						style={{
							fontSize: "1rem",
							fontWeight: "400",
							lineHeight: "1.2",
						}}
					>
						<Tooltip
							content={
								<div
									style={{
										width: "30rem",
										padding: "0.5rem",
									}}
								>
									<Video
										isInsideTooltip={true}
										videoSrc="https://kopy.b-cdn.net/reword_preview.webm"
									/>
								</div>
							}
						>
							<span className="info-underline">
								{t("upgrade_plus.ai_rewording")}
							</span>
						</Tooltip>
						<span> {t("upgrade_plus.for_product_details")}</span>
					</span>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "start",
						gap: "0.5rem",
						color: "#fff",
					}}
				>
					<svg width="1.2rem" height="1.2rem" viewBox="0 0 24 24">
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span
						style={{
							fontSize: "1rem",
							fontWeight: "400",
							lineHeight: "1.2",
						}}
					>
						<span>{t("upgrade_plus.get")} </span>
						<Tooltip
							content={
								<div
									style={{
										padding: "0.4rem 0.7rem",
										width: "20rem",
									}}
								>
									<p
										style={{
											fontSize: "0.9rem",
											color: "#333",
										}}
									>
										{t(
											"upgrade_plus.kopy_credits_are_the_official_currency",
										)}
									</p>
									<p
										style={{
											fontSize: "0.75rem",
											color: "#777",
											marginTop: "0.5rem",
										}}
									>
										{t(
											"upgrade_plus.translating_a_product_title_normally_uses_1_kopy_credit",
										)}
									</p>
								</div>
							}
						>
							<span className="info-underline">
								{t("upgrade_plus.5_000_kopy_credits")}
							</span>
						</Tooltip>
						<span> {t("upgrade_plus.for_free_every_month")}</span>
					</span>
				</div>

				<div
					style={{
						display: "flex",
						alignItems: "start",
						gap: "0.5rem",
						color: "#fff",
					}}
				>
					<svg width="1.2rem" height="1.2rem" viewBox="0 0 24 24">
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span
						style={{
							fontSize: "1rem",
							fontWeight: "400",
							lineHeight: "1.2",
						}}
					>
						<span>{t("ai.create_high-converting")} </span>
						<Tooltip
							content={
								<div
									style={{
										width: "30rem",
										height: "20rem",
										padding: "0.5rem",
									}}
								>
									<Video
										isInsideTooltip={true}
										videoSrc="https://kopy.b-cdn.net/kopy_pages_example.webm"
									/>
								</div>
							}
						>
							<span className="info-underline">
								{t("ai.product_pages")}
							</span>
						</Tooltip>
						<span> {t("ai.using_ai")}</span>
					</span>
				</div>
			</div>

			<div style={{ marginTop: "auto" }}>
				<GlowingButtonContainer
					intensity="medium"
					borderGlowEnabled={true}
				>
					<CoolButton onClick={onButtonClick}>
						{t("upgrade_plus.upgrade_now")}
						{buttonPrice ? (
							<Trans
								i18nKey="upgrade_basic.until_next_renewal"
								values={{
									price: new Intl.NumberFormat("en-US", {
										style: "currency",
										currency: "USD",
									}).format(buttonPrice),
								}}
							></Trans>
						) : (
							""
						)}
					</CoolButton>
				</GlowingButtonContainer>
			</div>
		</div>
	)
}

const KopyBasicPricingCard = ({
	billingInterval,
	priceInUsd,
	marginTopEnabled,
}) => {
	const { t } = useTranslation()

	return (
		<div
			className={`${marginTopEnabled ? "pricing-margin-top" : ""} pricing-card shadow`}
			style={{
				padding: "1.5rem",
				background: "#fff",
				borderRadius: "1rem",
				border: "1px solid #ccc",
			}}
		>
			<div style={{ display: "flex", gap: "1rem" }}>
				<div
					style={{
						position: "relative",
						width: "4rem",
						height: "4rem",
					}}
				>
					<img
						src={KopyLogo}
						style={{
							width: "4rem",
							height: "4rem",
							borderRadius: "1rem",
						}}
					/>
				</div>
				<div>
					<p
						style={{
							fontSize: "1.5rem",
							fontWeight: "bold",
							color: "#222",
						}}
					>
						Kopy Basic
					</p>
					<p
						style={{
							fontSize: "0.9rem",
							fontWeight: "400",
							color: "#444",
						}}
					>
						{t("upgrade_plus.store_subscription")}
					</p>
				</div>
			</div>

			<div
				style={{
					fontSize: "1.2rem",
					color: "#222",
					fontWeight: "600",
					marginTop: "1.3rem",
					lineHeight: "1.2",
					paddingBottom: "1rem",
					borderBottom: "1px solid #ccc8",
				}}
			>
				{t(
					"upgrade_plus.get_access_to_the_essentials_of_kopy_to_start_with_your_dropshipping_store",
				)}
			</div>

			<p style={{ fontSize: "3rem", fontWeight: "700", color: "#222" }}>
				${priceInUsd}
				<span style={{ fontSize: "1rem", fontWeight: "400" }}>
					{" "}
					/{" "}
					{billingInterval === "monthly"
						? "month"
						: billingInterval === "quarterly"
							? "quarterly"
							: "year"}
				</span>
			</p>

			<p
				style={{
					fontSize: "1.1rem",
					fontWeight: "500",
					color: "#222",
					marginTop: "1.2rem",
				}}
			>
				{t("upgrade_plus.whats_included")}
			</p>

			<div
				style={{
					fontSize: "1rem",
					marginTop: "0.7rem",
					marginBottom: "5rem",
					display: "flex",
					flexDirection: "column",
					gap: "0.5rem",
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
						color: "#222",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1.2rem"
						height="1.2rem"
						viewBox="0 0 24 24"
					>
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span style={{ fontSize: "1rem", fontWeight: "400" }}>
						{t("upgrade_plus.single_bulk_product_import")}
					</span>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
						color: "#222",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1.2rem"
						height="1.2rem"
						viewBox="0 0 24 24"
					>
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span style={{ fontSize: "1rem", fontWeight: "400" }}>
						{t("upgrade_plus.edit_product_before_importing")}
					</span>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
						color: "#222",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1.2rem"
						height="1.2rem"
						viewBox="0 0 24 24"
					>
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span style={{ fontSize: "1rem", fontWeight: "400" }}>
						{t("upgrade_plus.multi-platform_import_supported")}
					</span>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
						color: "#222",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1.2rem"
						height="1.2rem"
						viewBox="0 0 24 24"
					>
						<path
							fill="#d40000"
							d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-11.414L9.172 7.757L7.757 9.172L10.586 12l-2.829 2.828l1.415 1.415L12 13.414l2.828 2.829l1.415-1.415L13.414 12l2.829-2.828l-1.415-1.415z"
						></path>
					</svg>
					<span style={{ fontSize: "1rem", fontWeight: "400" }}>
						{t("upgrade_plus.ai_translation_and_copywriting")}
					</span>
				</div>
			</div>

			<Button fullWidth size="large" disabled>
				{t("upgrade_plus.current_plan")}
			</Button>
		</div>
	)
}

const KopyEnterprisePricingCard = ({
	billingInterval,
	priceInUsd,
	marginTopEnabled,
}) => {
	const { t } = useTranslation()

	return (
		<div
			className={`${marginTopEnabled ? "pricing-margin-top" : ""} pricing-card shadow`}
			style={{
				padding: "1.5rem",
				background: "#fff",
				borderRadius: "1rem",
				border: "1px solid #ccc",
			}}
		>
			<div style={{ display: "flex", gap: "1rem" }}>
				<div
					style={{
						position: "relative",
						width: "4rem",
						height: "4rem",
					}}
				>
					<img
						src={KopyLogo}
						style={{
							width: "4rem",
							height: "4rem",
							borderRadius: "1rem",
						}}
					/>
					<div
						style={{
							position: "absolute",
							top: "-0.4rem",
							right: "-0.4rem",
						}}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							style={{
								borderRadius: "0.2rem",
								background: "#222",
								height: "1.4rem",
								width: "1.4rem",
								padding: "0.2rem",
								color: "#fff",
							}}
							viewBox="0 0 512 512"
						>
							<path
								fill="currentColor"
								d="M256 0c4.6 0 9.2 1 13.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0m0 66.8v378C394 378 431.1 230.1 432 141.4z"
							></path>
						</svg>
					</div>
				</div>
				<div>
					<p
						style={{
							fontSize: "1.5rem",
							fontWeight: "bold",
							color: "#222",
						}}
					>
						Kopy Protect
					</p>
					<p
						style={{
							fontSize: "0.9rem",
							fontWeight: "400",
							color: "#444",
						}}
					>
						Add-on
					</p>
				</div>
			</div>

			<div
				style={{
					fontSize: "1.2rem",
					color: "#222",
					fontWeight: "600",
					marginTop: "1.3rem",
					lineHeight: "1.2",
					paddingBottom: "1rem",
					borderBottom: "1px solid #ccc8",
				}}
			>
				{t(
					"upgrade_plus.get_protection_for_your_store_and_be_aware_of_your_potential_competitors",
				)}
			</div>

			<p
				style={{
					fontSize: "3rem",
					fontWeight: "700",
					color: "#222",
					filter: "blur(8px)",
					opacity: "0.6",
					userSelect: "none",
				}}
			>
				${priceInUsd}
				<span style={{ fontSize: "1rem", fontWeight: "400" }}>
					{" "}
					{billingInterval === "monthly"
						? t("upgrade_plus.month")
						: billingInterval === "yearly"
							? t("account.year")
							: t("account.quarterly")}
				</span>
			</p>

			<p
				style={{
					fontSize: "1.1rem",
					fontWeight: "500",
					color: "#222",
					marginTop: "1.2rem",
				}}
			>
				{t("upgrade_plus.whats_included")}
			</p>

			<div
				style={{
					fontSize: "1rem",
					marginTop: "0.7rem",
					marginBottom: "2rem",
					display: "flex",
					flexDirection: "column",
					gap: "0.5rem",
					filter: "blur(8px)",
					opacity: "0.6",
					userSelect: "none",
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
						color: "#222",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1.2rem"
						height="1.2rem"
						viewBox="0 0 24 24"
					>
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span style={{ fontSize: "1rem", fontWeight: "400" }}>
						{t(
							"upgrade_plus.all_kopy_basic_and_kopy_plus_features",
						)}
					</span>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
						color: "#222",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1.2rem"
						height="1.2rem"
						viewBox="0 0 24 24"
					>
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span style={{ fontSize: "1rem", fontWeight: "400" }}>
						{t("upgrade_plus.protect_your_store_from_competitors")}
					</span>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
						color: "#222",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1.2rem"
						height="1.2rem"
						viewBox="0 0 24 24"
					>
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span style={{ fontSize: "1rem", fontWeight: "400" }}>
						{t("upgrade_plus.20_multiple_stores_free")}
					</span>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
						color: "#222",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1.2rem"
						height="1.2rem"
						viewBox="0 0 24 24"
					>
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span style={{ fontSize: "1rem", fontWeight: "400" }}>
						{t("upgrade_plus.10_000_kopy_credits_every_month")}
					</span>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
						color: "#222",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1.2rem"
						height="1.2rem"
						viewBox="0 0 24 24"
						style={{ flexShrink: "0" }}
					>
						<g fill="none" fillRule="evenodd">
							<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
							<path
								fill="currentColor"
								d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4z"
							></path>
						</g>
					</svg>
					<span style={{ fontSize: "1rem", fontWeight: "400" }}>
						{t(
							"upgrade_plus.get_notified_everytime_a_competitor_tries_to_kopy_your_store_products",
						)}
					</span>
				</div>
			</div>

			<div style={{ marginTop: "auto" }}>
				<Button fullWidth size="large" disabled>
					{t("upgrade_plus.coming_soon")}
				</Button>
			</div>
		</div>
	)
}

const UpgradePlus = () => {
	const posthog = usePostHog()
	const { state } = useContext(GlobalStateContext)
	const navigate = useNavigate()
	const { t } = useTranslation()
	const addItemToSubscription = useAddItemToSubscription()
	const getProratedPriceWithTax = useGetProratedPriceWithTax()

	const [billingInterval, setBillingInterval] = useState("monthly")
	const [proratedPriceWithTax, setProratedPriceWithTax] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)

	const activeSubscription =
		state.kopyBasicSubscription || state.kopyProtectSubscription || null

	const applicableKopyPlusPriceId =
		activeSubscription?.billingInterval === "monthly"
			? state.pricing?.["kopy_plus"]?.["monthly"]?.[
					state.hasTrialedKopyPlusBefore ? "no_trial" : "with_trial"
				]?.priceId || null
			: activeSubscription?.billingInterval === "yearly"
				? state.pricing?.["kopy_plus"]?.["yearly"]?.[
						state.hasTrialedKopyPlusBefore
							? "no_trial"
							: "with_trial"
					]?.priceId || null
				: activeSubscription?.billingInterval === "quarterly"
					? state.pricing?.["kopy_plus"]?.["quarterly"]?.[
							state.hasTrialedKopyPlusBefore
								? "no_trial"
								: "with_trial"
						]?.priceId || null
					: null

	const applicableKopyPlusPriceInUsd =
		activeSubscription?.billingInterval === "monthly"
			? state.pricing?.["kopy_plus"]?.["monthly"]?.[
					state.hasTrialedKopyPlusBefore ? "no_trial" : "with_trial"
				]?.priceInUsd || 0
			: activeSubscription?.billingInterval === "yearly"
				? state.pricing?.["kopy_plus"]?.["yearly"]?.[
						state.hasTrialedKopyPlusBefore
							? "no_trial"
							: "with_trial"
					]?.priceInUsd || 0
				: activeSubscription?.billingInterval === "quarterly"
					? state.pricing?.["kopy_plus"]?.["quarterly"]?.[
							state.hasTrialedKopyPlusBefore
								? "no_trial"
								: "with_trial"
						]?.priceInUsd || 0
					: null

	const changeBillingInterval = (interval) => {
		setBillingInterval(interval)
	}

	const confirmCreateSubscription = async () => {
		posthog?.capture("upgrade_to_kopy_plus_attempt")
		setError(null)

		setLoading(true)
		const { success, errorCode } = await addItemToSubscription({
			item: "plus",
			priceId: applicableKopyPlusPriceId,
		})
		setLoading(false)

		if (success) {
			window.location.reload()
		} else {
			setError(
				`Failed to upgrade subscription${errorCode === "subscription_payment_declined" ? ": Payment Declined" : ""}`,
			)
			posthog?.capture("upgrade_to_kopy_plus_failure")
		}
	}

	useEffect(() => {
		if (state.hasValidKopyPlusSubscription) {
			navigate("/")
		} else {
			posthog?.capture("user_visits_upgrade_plus_page_v2")
		}
	}, [state.kopyPlusSubscription])

	useEffect(() => {
		const activeSubscriptionId = activeSubscription?.subscriptionId || null

		if (activeSubscription?.billingInterval === "yearly") {
			setBillingInterval("yearly")
		}

		if (activeSubscription?.billingInterval === "quarterly") {
			setBillingInterval("quarterly")
		}

		if (applicableKopyPlusPriceId && activeSubscriptionId) {
			getProratedPriceWithTax({
				subscriptionId: activeSubscriptionId,
				newSubscriptionItem: {
					price_id: applicableKopyPlusPriceId,
					quantity: 1,
				},
			}).then(({ proratedPriceWithTax }) => {
				if (proratedPriceWithTax) {
					setProratedPriceWithTax(proratedPriceWithTax)
				}
			})
		}
	}, [state.kopyPlusSubscription])

	return (
		<div>
			<TopMenu goBack="/" storeSelector />

			<div
				style={{
					height: "100%",
					padding: "1rem",
					paddingTop: "5rem",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					gap: "1rem",
				}}
			>
				{/* <div
					className="shadow"
					style={{
						background: "#fff",
						border: "1px solid #ccc",
						borderRadius: "1rem",
						padding: "0.7rem 1rem",
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="2.3rem"
						height="2.3rem"
						viewBox="0 0 24 24"
					>
						<path
							d="M12 2C9.243 2 7 4.243 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9V7zm4 10.723V20h-2v-2.277a1.993 1.993 0 0 1 .567-3.677A2.001 2.001 0 0 1 14 16a1.99 1.99 0 0 1-1 1.723z"
							fill="currentColor"
						></path>
					</svg>
					<h1
						style={{
							fontSize: "2.5rem",
							fontWeight: "700",
							color: "#000",
							lineHeight: "1.1",
							textAlign: "center",
						}}
					>
						{t("upgrade_plus.unlock_access_to_kopy_ai")}
					</h1>
				</div> */}

				<div
					className="pricing-table"
					style={{
						display: "flex",
						justifyContent: "center",
						gap: "1.5rem",
						marginTop: "2rem",
						flexWrap: "wrap",
					}}
				>
					<KopyPlusPricingCard
						billingInterval={billingInterval}
						priceInUsd={applicableKopyPlusPriceInUsd}
						onButtonClick={
							loading ? null : confirmCreateSubscription
						}
						buttonPrice={proratedPriceWithTax}
					/>
				</div>

				{loading && <Spinner />}

				{error ? (
					<div
						style={{
							background: "#ff2f2f",
							padding: "1rem",
							borderRadius: "0.5rem",
							marginBottom: "1rem",
						}}
					>
						<p
							style={{
								fontSize: "0.9rem",
								fontWeight: "600",
								color: "#fff",
								marginBottom: "1rem",
							}}
						>
							{error}
						</p>
						<p
							style={{
								fontSize: "0.85rem",
								fontWeight: "500",
								color: "#fff",
								marginBottom: "1rem",
							}}
						>
							If upgrading keeps failing, please check that you
							have a valid payment method.
						</p>
						{activeSubscription?.updatePaymentMethodUrl && (
							<Button
								fullWidth
								onClick={() =>
									window.open(
										activeSubscription?.updatePaymentMethodUrl,
										"_blank",
									)
								}
							>
								Update Payment Method
							</Button>
						)}
					</div>
				) : (
					""
				)}
			</div>

			<style>{`
				.pricing-table {
					flex-wrap: nowrap;
				}
				.pricing-card {
					// width: 50%;
					max-width: 26rem;
					display: flex;
					flex-direction: column;
				}
				.pricing-margin-top {
					margin-top: 2.5rem;
				}
				
				@media screen and (max-width: 1100px) {
					.pricing-table {
						flex-wrap: wrap;
					}
					.pricing-card {
						width: 100%;
					}
					.pricing-margin-top {
						margin-top: 0rem;
					}
				}
			`}</style>
		</div>
	)
}

export default UpgradePlus
